export const SUPER_ADMIN_ROLE_ID = 1;

export default {
	CAN_ASSIGN_KYC_AGENTS: 'assign_kyc-agent',
	CAN_VIEW_MANUAL_KYC_ADMIN: 'is_manual-kyc-admin',
	CAN_VIEW_MANUAL_KYC: 'can_view_manual_kyc',
	CAN_VIEW_MANUAL_KYC_QA: 'can_view-manual-kyc-qa',
	CAN_VIEW_SHOP_VALIDATOR: 'can_view_shop_validator_list',
	CAN_VIEW_SHOP_VALIDATOR_ADMIN: 'is_shop-validator-admin',
	CAN_VIEW_SWIPE_KYC_LIST: 'can_view_swipe_kyc_list',
	CAN_VIEW_DIGITAL_KYC: 'is-digi_kyc_view',
};
